
import { concat, join, isNullOrWhiteSpace } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { sortBy, filter, singleton as singleton_1, map as map_2, toArray, ofArray, exists, isEmpty, empty, tryFind, cons } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { comparePrimitives, safeHash, structuralHash, createObj, stringHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { mapIndexed, collect, concat as concat_1, append as append_1, tryFindIndex, insertAt, item, contains, tryFind as tryFind_1, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { fromDateTime } from "../../fable_modules/fable-library-js.5.0.0-rc.2/DateOnly.js";
import { toString, compare, equals as equals_1, toLocalTime, parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ofNullable, map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { reactElement as reactElement_1, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map as map_3, singleton, empty as empty_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { useTranslation } from "react-i18next";
import { useDrop, useDrag } from "../../Bindings/Fable.ReactDnD.js";
import Hamburger_Menu_1 from "../../../public/assets/icons/Hamburger_Menu_1.svg";
import Arrow_Up_3 from "../../../public/assets/icons/Arrow_Up_3.svg";
import Arrow_Down_3 from "../../../public/assets/icons/Arrow_Down_3.svg";
import { IconInput, Input } from "../../Components/Input.js";
import { getColumnVisibilityObject, update as update_1, init as init_1, setQueryParams } from "./State.js";
import { FSharpMap__TryFind, tryFind as tryFind_2, FSharpMap__get_Item } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { CategorySelectFilter, SelectFilter } from "./SelectFilter.js";
import { Array_distinctBy, Array_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { RangeDatePicker } from "../../Components/DatePicker.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { TooltipAnchor } from "../../Components/TooltipAnchor.js";
import { Badge } from "../../Components/Badge.js";
import { ImageViewer } from "../../Components/ImageViewer.js";
import { TextButton } from "../../Components/Button.js";
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, record_type, bool_type, lambda_type, unit_type, list_type, option_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { TableMsg$1 } from "./Types.js";
import { getSortedRowModel as getSortedRowModel_1, getFilteredRowModel as getFilteredRowModel_1, getCoreRowModel as getCoreRowModel_1, useReactTable } from "@tanstack/react-table";
import { TableSettings, TableElementsCounter } from "./TableControlHeader.js";
import Magnifying_Glass from "../../../public/assets/icons/Magnifying_Glass.svg";
import { ColumnSelect } from "./ColumnSelect.js";
import { TableFilterDropDown } from "./CustomFilters.js";
import Compress from "../../../public/assets/icons/Compress.svg";
import Expand from "../../../public/assets/icons/Expand.svg";

export function normalizeFilterValue(value) {
    if (isNullOrWhiteSpace(value)) {
        return "__empty__";
    }
    else {
        return value;
    }
}

export function labelHierarchyName(labels, leaf) {
    const walkUp = (acc_mut, current_mut) => {
        walkUp:
        while (true) {
            const acc = acc_mut, current = current_mut;
            const matchValue = current.ParentLabelId;
            if (matchValue == null) {
                return cons(current.Name, acc);
            }
            else {
                const parentId = matchValue;
                const matchValue_1 = tryFind((l) => equals(l.Id, parentId), labels);
                if (matchValue_1 == null) {
                    return cons(current.Name, acc);
                }
                else {
                    acc_mut = cons(current.Name, acc);
                    current_mut = matchValue_1;
                    continue walkUp;
                }
            }
            break;
        }
    };
    return join(" > ", walkUp(empty(), leaf));
}

export function createColumnDefinition(columnDefinitions, columnFilters) {
    return map((columnDefinition) => {
        let matchValue_1, matchValue_5;
        return {
            accessorFn: (row) => {
                const matchValue = columnDefinition.AccessorFunction(row);
                switch (matchValue.tag) {
                    case 1:
                        return matchValue.fields[0];
                    case 2:
                        return matchValue.fields[0];
                    case 3:
                        return matchValue.fields[0];
                    case 4:
                        return matchValue.fields[0];
                    case 5:
                        return matchValue.fields[0];
                    case 6:
                        return matchValue.fields[0];
                    case 7:
                        return matchValue.fields[0];
                    default:
                        return matchValue.fields[0];
                }
            },
            enableSorting: columnDefinition.Id !== "image",
            filterFn: (matchValue_1 = columnDefinition.Filter, (matchValue_1 === "text") ? "includesString" : ((matchValue_1 === "select") ? ((a) => {
                const filterValue = tryFind_1((columnFilter) => (columnFilter.id === columnDefinition.Id), columnFilters);
                const matchValue_2 = columnDefinition.AccessorFunction(a.original);
                switch (matchValue_2.tag) {
                    case 1:
                        return true;
                    case 2:
                        if (filterValue == null) {
                            return true;
                        }
                        else {
                            const filterValues_1 = filterValue.value;
                            return contains(normalizeFilterValue(matchValue_2.fields[0]), filterValues_1, {
                                Equals: (x_1, y_1) => (x_1 === y_1),
                                GetHashCode: (x_1) => (stringHash(x_1) | 0),
                            });
                        }
                    case 4:
                    case 5:
                        return true;
                    case 3: {
                        const labels_1 = matchValue_2.fields[0];
                        if (filterValue == null) {
                            return true;
                        }
                        else {
                            const filterValues_2 = filterValue.value;
                            if (isEmpty(labels_1)) {
                                return contains("__empty__", filterValues_2, {
                                    Equals: (x_2, y_2) => (x_2 === y_2),
                                    GetHashCode: (x_2) => (stringHash(x_2) | 0),
                                });
                            }
                            else {
                                const labels_2 = labels_1;
                                return exists((label_2) => {
                                    if (contains(normalizeFilterValue(label_2.Name), filterValues_2, {
                                        Equals: (x_3, y_3) => (x_3 === y_3),
                                        GetHashCode: (x_3) => (stringHash(x_3) | 0),
                                    })) {
                                        return true;
                                    }
                                    else {
                                        return contains(labelHierarchyName(labels_2, label_2), filterValues_2, {
                                            Equals: (x_4, y_4) => (x_4 === y_4),
                                            GetHashCode: (x_4) => (stringHash(x_4) | 0),
                                        });
                                    }
                                }, labels_2);
                            }
                        }
                    }
                    case 6:
                        return true;
                    case 7:
                        return true;
                    default:
                        if (filterValue == null) {
                            return true;
                        }
                        else {
                            const filterValues = filterValue.value;
                            return contains(normalizeFilterValue(matchValue_2.fields[0]), filterValues, {
                                Equals: (x, y) => (x === y),
                                GetHashCode: (x) => (stringHash(x) | 0),
                            });
                        }
                }
            }) : ((matchValue_1 === "categorySelect") ? ((a) => {
                const filterValue = tryFind_1((columnFilter) => (columnFilter.id === columnDefinition.Id), columnFilters);
                const matchValue_2 = columnDefinition.AccessorFunction(a.original);
                switch (matchValue_2.tag) {
                    case 1:
                        return true;
                    case 2:
                        if (filterValue == null) {
                            return true;
                        }
                        else {
                            const filterValues_1 = filterValue.value;
                            return contains(normalizeFilterValue(matchValue_2.fields[0]), filterValues_1, {
                                Equals: (x_1, y_1) => (x_1 === y_1),
                                GetHashCode: (x_1) => (stringHash(x_1) | 0),
                            });
                        }
                    case 4:
                    case 5:
                        return true;
                    case 3: {
                        const labels_1 = matchValue_2.fields[0];
                        if (filterValue == null) {
                            return true;
                        }
                        else {
                            const filterValues_2 = filterValue.value;
                            if (isEmpty(labels_1)) {
                                return contains("__empty__", filterValues_2, {
                                    Equals: (x_2, y_2) => (x_2 === y_2),
                                    GetHashCode: (x_2) => (stringHash(x_2) | 0),
                                });
                            }
                            else {
                                const labels_2 = labels_1;
                                return exists((label_2) => {
                                    if (contains(normalizeFilterValue(label_2.Name), filterValues_2, {
                                        Equals: (x_3, y_3) => (x_3 === y_3),
                                        GetHashCode: (x_3) => (stringHash(x_3) | 0),
                                    })) {
                                        return true;
                                    }
                                    else {
                                        return contains(labelHierarchyName(labels_2, label_2), filterValues_2, {
                                            Equals: (x_4, y_4) => (x_4 === y_4),
                                            GetHashCode: (x_4) => (stringHash(x_4) | 0),
                                        });
                                    }
                                }, labels_2);
                            }
                        }
                    }
                    case 6:
                        return true;
                    case 7:
                        return true;
                    default:
                        if (filterValue == null) {
                            return true;
                        }
                        else {
                            const filterValues = filterValue.value;
                            return contains(normalizeFilterValue(matchValue_2.fields[0]), filterValues, {
                                Equals: (x, y) => (x === y),
                                GetHashCode: (x) => (stringHash(x) | 0),
                            });
                        }
                }
            }) : ((matchValue_1 === "dateRange") ? ((row_1) => {
                const matchValue_3 = columnDefinition.AccessorFunction(row_1.original);
                switch (matchValue_3.tag) {
                    case 1:
                        return true;
                    case 2:
                        return true;
                    case 4:
                        return true;
                    case 5:
                        return true;
                    case 3:
                        return true;
                    case 0:
                        return true;
                    case 7:
                        return true;
                    default:
                        if (matchValue_3.fields[0] == null) {
                            return false;
                        }
                        else {
                            const value_6 = matchValue_3.fields[0];
                            const filterValue_4 = tryFind_1((columnFilter_1) => (columnFilter_1.id === columnDefinition.Id), columnFilters);
                            if (filterValue_4 == null) {
                                return false;
                            }
                            else {
                                const filterValues_3 = map((arg) => fromDateTime(parse(arg)), filterValue_4.value);
                                const dateValue = fromDateTime(toLocalTime(value_6));
                                const matchValue_4 = filterValues_3.length | 0;
                                return (matchValue_4 === 0) ? false : ((matchValue_4 === 1) ? equals_1(item(0, filterValues_3), dateValue) : ((matchValue_4 === 2) && ((compare(item(0, filterValues_3), dateValue) <= 0) && (compare(dateValue, item(1, filterValues_3)) <= 0))));
                            }
                        }
                }
            }) : "includesString")))),
            header: columnDefinition.Header,
            id: columnDefinition.Id,
            size: unwrap((columnDefinition.ColumnType === "image") ? 75 : undefined),
            sortingFn: (matchValue_5 = columnDefinition.ColumnType, (matchValue_5 === "image") ? "alphanumeric" : ((matchValue_5 === "button") ? "alphanumeric" : ((matchValue_5 === "date") ? "datetime" : ((matchValue_5 === "dateTime") ? "datetime" : "alphanumeric")))),
        };
    }, columnDefinitions);
}

export function BaseTableHeader(props) {
    const dependencies_1 = [props.Children];
    return reactApi.useMemo(() => reactElement_1("div", createObj(toList(delay(() => {
        let matchValue;
        return append((matchValue = props.DropRef, (matchValue == null) ? (empty_1()) : singleton(["ref", matchValue])), delay(() => append(singleton(["style", {
            minWidth: props.Width,
            width: props.Width,
        }]), delay(() => append(singleton(["className", join(" ", toList(delay(() => append(singleton("grow"), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = props.BorderStyle, (matchValue_1 === "full") ? singleton("border") : ((matchValue_1 === "row") ? (empty_1()) : (empty_1()))), delay(() => append(singleton("border-border"), delay(() => append(singleton("py-2.5"), delay(() => append(singleton("px-4"), delay(() => append(singleton("h-full"), delay(() => append(props.StickyHeader ? append(singleton("sticky"), delay(() => singleton("top-0"))) : empty_1(), delay(() => append(singleton("bg-white"), delay(() => append(singleton("relative"), delay(() => props.Classes))))))))))))))));
        })))))]), delay(() => {
            let elems_1;
            return singleton((elems_1 = toList(delay(() => append(singleton(reactElement_1("div", createObj(toList(delay(() => {
                let matchValue_2;
                return append((matchValue_2 = props.PreviewRef, (matchValue_2 == null) ? (empty_1()) : singleton(["ref", matchValue_2])), delay(() => append(singleton(["className", join(" ", ["flex", "flex-col", "justify-between", "gap-3", "h-full"])]), delay(() => {
                    let elems;
                    return singleton((elems = toList(delay(() => props.Children)), ["children", reactApi.Children.toArray(Array.from(elems))]));
                }))));
            }))))), delay(() => {
                const matchValue_3 = props.Header;
                if (matchValue_3 == null) {
                    return empty_1();
                }
                else {
                    const header = matchValue_3;
                    return singleton(reactElement_1("div", {
                        onMouseDown: header.getResizeHandler(),
                        className: join(" ", toList(delay(() => append(singleton("absolute"), delay(() => append(singleton("right-0"), delay(() => append(singleton("top-0"), delay(() => append(singleton("h-full"), delay(() => {
                            let matchValue_4;
                            return append((matchValue_4 = props.BorderStyle, (matchValue_4 === "row") ? (empty_1()) : ((matchValue_4 === "none") ? (empty_1()) : singleton("border-r"))), delay(() => append(singleton("bg-border"), delay(() => append(singleton("border-border"), delay(() => singleton("cursor-col-resize")))))));
                        }))))))))))),
                    }));
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))]));
        }))))));
    })))), dependencies_1);
}

export function TableHeader(props) {
    let elems_4, elems_5;
    const t = useTranslation()[0];
    const columnOrder = props.Table.getState().columnOrder;
    const column = props.Header.column;
    const patternInput_1 = reactApi.useState("");
    const selectSearchValue = patternInput_1[0];
    const patternInput_2 = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => column,
        type: "column",
    });
    const previewRef = patternInput_2[2];
    const patternInput_3 = useDrop({
        accept: "column",
        drop: (draggedColumn) => {
            let arg;
            const draggedColumnId = draggedColumn.id;
            const targetColumnId = column.id;
            const columnOrder_1 = columnOrder;
            const newOrder = columnOrder_1.filter((columnId) => (columnId !== draggedColumnId));
            arg = defaultArg(map_1((index) => insertAt(index + 1, draggedColumnId, newOrder), tryFindIndex((columnId_1) => (columnId_1 === targetColumnId), newOrder)), columnOrder_1);
            props.Table.setColumnOrder(arg);
        },
    });
    return createElement(BaseTableHeader, {
        BorderStyle: props.BorderStyle,
        Children: ofArray([reactElement_1("div", createObj(ofArray([["ref", previewRef], ["className", join(" ", ["flex", "gap-x-2", "items-center"])], ["data-test-id", concat("table-column-header-", ...props.ColumnId)], (elems_4 = toList(delay(() => {
            let elems;
            return append(props.IsDraggable ? singleton(reactElement_1("div", createObj(ofArray([["ref", patternInput_2[1]], ["className", join(" ", ["h-3", "w-3"])], (elems = [Hamburger_Menu_1()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_1(), delay(() => append(singleton(reactElement_1("div", {
                className: join(" ", ["flex", "text-sm", "font-semibold", "text-left"]),
                children: props.Text,
            })), delay(() => {
                let elems_3;
                return singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["h-3", "ml-auto"])], (elems_3 = toList(delay(() => {
                    let elems_1, elems_2;
                    const matchValue = props.Header.column.getIsSorted();
                    switch (matchValue) {
                        case "asc":
                            return singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["ml-2.5", "h-3", "w-3", "stroke-2", "text-primary"])], (elems_1 = [Arrow_Up_3()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                        case "desc":
                            return singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["ml-2.5", "h-3", "w-3", "stroke-2", "text-primary"])], (elems_2 = [Arrow_Down_3()], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                        default: {
                            return empty_1();
                        }
                    }
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
            }))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_4))]), ["onClick", props.Header.column.getToggleSortingHandler()]]))), reactElement_1("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_5 = toList(delay(() => {
            let dependencies_1, dependencies_1_1, dependencies_1_2, dependencies_1_3;
            const matchValue_1 = props.ColumnFilter;
            switch (matchValue_1) {
                case "text":
                    return singleton((dependencies_1 = [props.FilterValue], reactApi.useMemo(() => {
                        let Value;
                        return createElement(Input, (Value = defaultArg(ofNullable(props.FilterValue), ""), {
                            ComponentState: "enabled",
                            OnChange: (value_22) => {
                                if (props.SetQueryParams) {
                                    setQueryParams(props.ColumnId, value_22);
                                }
                                props.OnFilter(value_22);
                            },
                            TestId: concat("table-column-filter-", props.Key, ..."-input"),
                            Value: Value,
                        }));
                    }, dependencies_1)));
                case "select": {
                    const columnDefinition = FSharpMap__get_Item(props.ColumnDefinitionMap, props.ColumnId);
                    const tableColumn = props.Table.getColumn(props.ColumnId);
                    const filterValues = ofNullable(tableColumn.getFilterValue());
                    return singleton((dependencies_1_1 = [filterValues, props.Table.getCoreRowModel().rows, selectSearchValue], reactApi.useMemo(() => {
                        let array_4;
                        return createElement(SelectFilter, {
                            ButtonLabel: t("table.selection"),
                            ComponentState: "enabled",
                            Items: ofArray(map((value_26) => {
                                const Label_1 = (value_26.Name === "__empty__") ? t("table.filter_empty_option") : value_26.Name;
                                return {
                                    Checked: (filterValues == null) ? false : contains(value_26.Name, filterValues, {
                                        Equals: (x_1, y_1) => (x_1 === y_1),
                                        GetHashCode: (x_1) => (stringHash(x_1) | 0),
                                    }),
                                    Id: value_26.Name,
                                    Label: Label_1,
                                    OnCheck: (_arg_3) => {
                                        let newFilterValue;
                                        if (filterValues == null) {
                                            newFilterValue = [value_26.Name];
                                        }
                                        else {
                                            const filterValues_2 = filterValues;
                                            newFilterValue = (contains(value_26.Name, filterValues_2, {
                                                Equals: (x_2, y_2) => (x_2 === y_2),
                                                GetHashCode: (x_2) => (stringHash(x_2) | 0),
                                            }) ? filterValues_2.filter((filterValue) => (filterValue !== value_26.Name)) : append_1([value_26.Name], filterValues_2));
                                        }
                                        if (newFilterValue.length === 0) {
                                            if (props.SetQueryParams) {
                                                setQueryParams(props.ColumnId, "");
                                            }
                                            props.OnFilter(undefined);
                                        }
                                        else {
                                            if (props.SetQueryParams) {
                                                setQueryParams(props.ColumnId, newFilterValue.reduce((a, b) => concat(a, ",", ...b)));
                                            }
                                            props.OnFilter(newFilterValue);
                                        }
                                    },
                                };
                            }, (array_4 = Array_distinct(concat_1(map((row) => {
                                const matchValue_2 = columnDefinition.AccessorFunction(row.original);
                                let matchResult, value_24, label, labels;
                                switch (matchValue_2.tag) {
                                    case 1: {
                                        matchResult = 1;
                                        break;
                                    }
                                    case 4:
                                    case 5: {
                                        matchResult = 3;
                                        break;
                                    }
                                    case 6: {
                                        matchResult = 6;
                                        break;
                                    }
                                    case 7: {
                                        matchResult = 7;
                                        break;
                                    }
                                    case 2: {
                                        matchResult = 2;
                                        label = matchValue_2.fields[0];
                                        break;
                                    }
                                    case 3: {
                                        if (isEmpty(matchValue_2.fields[0])) {
                                            matchResult = 4;
                                        }
                                        else {
                                            matchResult = 5;
                                            labels = matchValue_2.fields[0];
                                        }
                                        break;
                                    }
                                    default: {
                                        matchResult = 0;
                                        value_24 = matchValue_2.fields[0];
                                    }
                                }
                                switch (matchResult) {
                                    case 0:
                                        return [{
                                            Name: normalizeFilterValue(value_24),
                                        }];
                                    case 1:
                                        return [];
                                    case 2:
                                        return [{
                                            Name: normalizeFilterValue(label),
                                        }];
                                    case 3:
                                        return [];
                                    case 4:
                                        return [{
                                            Name: "__empty__",
                                        }];
                                    case 5:
                                        return toArray(map_2((l) => ({
                                            Name: normalizeFilterValue(l.Name),
                                        }), labels));
                                    case 6:
                                        return [];
                                    default:
                                        return [];
                                }
                            }, props.Table.getCoreRowModel().rows)), {
                                Equals: equals,
                                GetHashCode: (x) => (structuralHash(x) | 0),
                            }), array_4.filter((value_25) => {
                                if (value_25.Name === "__empty__") {
                                    return true;
                                }
                                else {
                                    return value_25.Name.toLocaleLowerCase().indexOf(selectSearchValue.toLocaleLowerCase()) >= 0;
                                }
                            })))),
                            OnDeselectAll: () => {
                                if (props.SetQueryParams) {
                                    setQueryParams(props.ColumnId, "");
                                }
                                props.OnFilter(undefined);
                            },
                            OnResetFilter: () => {
                                if (props.SetQueryParams) {
                                    setQueryParams(props.ColumnId, "");
                                }
                                props.OnFilter(undefined);
                            },
                            OnSearch: patternInput_1[1],
                            OnSelectAll: (ids) => {
                                const idsArray = toArray(ids);
                                const newFilterValue_1 = (filterValues == null) ? idsArray : Array_distinct(append_1(filterValues, idsArray), {
                                    Equals: (x_3, y_3) => (x_3 === y_3),
                                    GetHashCode: (x_3) => (stringHash(x_3) | 0),
                                });
                                if (props.SetQueryParams) {
                                    setQueryParams(props.ColumnId, newFilterValue_1.reduce((a_1, b_1) => concat(a_1, ",", ...b_1)));
                                }
                                props.OnFilter(newFilterValue_1);
                            },
                            SearchValue: selectSearchValue,
                            TestId: concat(props.Key, ..."-search-value-input"),
                        });
                    }, dependencies_1_1)));
                }
                case "categorySelect": {
                    const columnDefinition_1 = FSharpMap__get_Item(props.ColumnDefinitionMap, props.ColumnId);
                    const tableColumn_1 = props.Table.getColumn(props.ColumnId);
                    const filterValues_3 = ofNullable(tableColumn_1.getFilterValue());
                    const rows = props.Table.getCoreRowModel().rows;
                    const categoryLabels = ofArray(Array_distinctBy((_arg_6) => _arg_6.Id, collect((row_1) => {
                        const matchValue_3 = columnDefinition_1.AccessorFunction(row_1.original);
                        if (matchValue_3.tag === 3) {
                            return toArray(matchValue_3.fields[0]);
                        }
                        else {
                            return [];
                        }
                    }, rows), {
                        Equals: equals,
                        GetHashCode: (x_4) => (safeHash(x_4) | 0),
                    }));
                    const hasEmptyRows = rows.some((row_2) => {
                        const matchValue_4 = columnDefinition_1.AccessorFunction(row_2.original);
                        let matchResult_1;
                        if (matchValue_4.tag === 3) {
                            if (isEmpty(matchValue_4.fields[0])) {
                                matchResult_1 = 0;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0:
                                return true;
                            default:
                                return false;
                        }
                    });
                    return singleton((dependencies_1_2 = [filterValues_3, props.Table.getCoreRowModel().rows], reactApi.useMemo(() => createElement(CategorySelectFilter, {
                        ButtonLabel: t("table.selection"),
                        HasEmptyOption: hasEmptyRows,
                        Labels: categoryLabels,
                        OnFilterChange: (newFilterValue_2) => {
                            if (newFilterValue_2.length === 0) {
                                if (props.SetQueryParams) {
                                    setQueryParams(props.ColumnId, "");
                                }
                                props.OnFilter(undefined);
                            }
                            else {
                                if (props.SetQueryParams) {
                                    setQueryParams(props.ColumnId, newFilterValue_2.reduce((a_2, b_2) => concat(a_2, ",", ...b_2)));
                                }
                                props.OnFilter(newFilterValue_2);
                            }
                        },
                        SelectedValues: unwrap(filterValues_3),
                        TestId: props.Key,
                    }), dependencies_1_2)));
                }
                case "dateRange": {
                    const tableColumn_2 = props.Table.getColumn(props.ColumnId);
                    const filterValues_4 = map_1((array_22) => map(parse, array_22), ofNullable(tableColumn_2.getFilterValue()));
                    let patternInput_4;
                    if (filterValues_4 == null) {
                        patternInput_4 = [undefined, undefined];
                    }
                    else {
                        const values = filterValues_4;
                        const matchValue_5 = values.length | 0;
                        patternInput_4 = ((matchValue_5 === 0) ? [undefined, undefined] : ((matchValue_5 === 1) ? [item(0, values), undefined] : ((matchValue_5 === 2) ? [item(0, values), item(1, values)] : [undefined, undefined])));
                    }
                    const startDate = patternInput_4[0];
                    const endDate = patternInput_4[1];
                    return singleton((dependencies_1_3 = [props.FilterValue, startDate, endDate], reactApi.useMemo(() => createElement(RangeDatePicker, {
                        ComponentState: "enabled",
                        EndDate: unwrap(endDate),
                        IsClearable: true,
                        OnChange: (value_31) => {
                            if (value_31 == null) {
                                if (props.SetQueryParams) {
                                    setQueryParams(props.ColumnId, "");
                                }
                                props.OnFilter(undefined);
                            }
                            else {
                                const dateRange = value_31;
                                const matchValue_6 = dateRange.EndDate;
                                if (matchValue_6 == null) {
                                    const filterValue_2 = toString(dateRange.StartDate, "yyyy-MM-dd");
                                    if (props.SetQueryParams) {
                                        setQueryParams(props.ColumnId, filterValue_2);
                                    }
                                    props.OnFilter([filterValue_2]);
                                }
                                else {
                                    const endDate_1 = matchValue_6;
                                    const startDate_1 = toString(dateRange.StartDate, "yyyy-MM-dd");
                                    const endDate_2 = toString(endDate_1, "yyyy-MM-dd");
                                    if (props.SetQueryParams) {
                                        setQueryParams(props.ColumnId, concat(startDate_1, ",", ...endDate_2));
                                    }
                                    props.OnFilter([startDate_1, endDate_2]);
                                }
                            }
                        },
                        StartDate: unwrap(startDate),
                        TestId: concat("table-column-filter-", props.Key, ..."-range-date-input"),
                    }), dependencies_1_3)));
                }
                default:
                    return singleton(reactElement_1("div", {
                        className: join(" ", ["grow"]),
                    }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))]),
        Classes: empty(),
        DropRef: patternInput_3[1],
        Header: props.Header,
        PreviewRef: previewRef,
        SetHeaderSize: props.SetHeaderSize,
        StickyHeader: props.StickyHeader,
        Table: props.Table,
        Width: props.Header.getSize(),
    });
}

export function CheckboxTableHeader(props) {
    const dependencies_1 = [props.Checked];
    return reactApi.useMemo(() => {
        let elems;
        return createElement(BaseTableHeader, {
            BorderStyle: props.BorderStyle,
            Children: singleton_1(reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "grow"])], (elems = toList(delay(() => (props.IsCheckboxVisible ? singleton(Checkbox({
                ComponentState: "enabled",
                IsChecked: props.Checked,
                Label: "",
                OnCheck: props.OnCheck,
                TestId: "",
            })) : empty_1()))), ["children", reactApi.Children.toArray(Array.from(elems))])])))),
            Classes: singleton_1("w-0"),
            SetHeaderSize: false,
            StickyHeader: props.StickyHeader,
            Table: props.Table,
            Width: 40,
        });
    }, dependencies_1);
}

export function BaseTableCellXX(props) {
    return reactElement_1("div", createObj(toList(delay(() => append(singleton(["data-test-id", props.TestId]), delay(() => append(singleton(["className", join(" ", toList(delay(() => append(singleton("grow"), delay(() => {
        let matchValue;
        return append((matchValue = props.BorderStyle, (matchValue === "full") ? singleton("border") : ((matchValue === "row") ? singleton("border-y") : (empty_1()))), delay(() => append(singleton("border-border"), delay(() => append(singleton("py-2.5"), delay(() => append(singleton("px-4"), delay(() => singleton("group-hover:bg-[#F2F4FD]")))))))));
    })))))]), delay(() => append(singleton(["style", {
        minWidth: props.Width,
        width: props.Width,
    }]), delay(() => {
        let elems;
        return append(singleton((elems = toList(delay(() => {
            const matchValue_1 = props.OnClick;
            let matchResult, url;
            if (matchValue_1 == null) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                url = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton(reactElement_1("a", {
                        className: join(" ", ["block", "h-full", "w-full", "break-words"]),
                        href: url(props.Row.original),
                        children: props.Text,
                    }));
                default:
                    return singleton(reactElement_1("div", {
                        children: props.Text,
                    }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems))])), delay(() => {
            let url_1, onClick;
            const matchValue_2 = props.OnClick;
            if (matchValue_2 == null) {
                return empty_1();
            }
            else {
                return (matchValue_2.tag === 1) ? ((url_1 = matchValue_2.fields[0], singleton(["onClick", (_arg_1) => {
                    RouterModule_nav(singleton_1(url_1(props.Row.original)), 1, 1);
                }]))) : ((onClick = matchValue_2.fields[0], singleton(["onClick", (_arg) => {
                    onClick(props.Row.original);
                }])));
            }
        }));
    }))))))))));
}

export function BaseTableCell(props) {
    return reactElement_1("div", createObj(toList(delay(() => append(singleton(["data-test-id", props.TestId]), delay(() => append(singleton(["className", join(" ", toList(delay(() => append(singleton("grow"), delay(() => {
        let matchValue;
        return append((matchValue = props.BorderStyle, (matchValue === "full") ? singleton("border") : ((matchValue === "row") ? singleton("border-y") : (empty_1()))), delay(() => append(singleton("border-border"), delay(() => append(singleton("py-2.5"), delay(() => append(singleton("px-4"), delay(() => singleton("group-hover:bg-[#F2F4FD]")))))))));
    })))))]), delay(() => append(singleton(["style", {
        minWidth: props.Width,
        width: props.Width,
    }]), delay(() => {
        let elems_1;
        return append(singleton((elems_1 = toList(delay(() => {
            const matchValue_1 = props.OnClick;
            let matchResult, url;
            if (matchValue_1 == null) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                url = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton(reactElement_1("a", {
                        className: join(" ", ["block", "h-full", "w-full", "break-words"]),
                        href: url(props.Row.original),
                        children: reactApi.Children.toArray([props.Content]),
                    }));
                default:
                    return singleton(reactElement_1("div", {
                        children: reactApi.Children.toArray([props.Content]),
                    }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])), delay(() => {
            let url_1, onClick;
            const matchValue_2 = props.OnClick;
            if (matchValue_2 == null) {
                return empty_1();
            }
            else {
                return (matchValue_2.tag === 1) ? ((url_1 = matchValue_2.fields[0], singleton(["onClick", (_arg_1) => {
                    RouterModule_nav(singleton_1(url_1(props.Row.original)), 1, 1);
                }]))) : ((onClick = matchValue_2.fields[0], singleton(["onClick", (_arg) => {
                    onClick(props.Row.original);
                }])));
            }
        }));
    }))))))))));
}

export function TextTableCell(props) {
    const dependencies_1 = [props.Text, props.Cell];
    return reactApi.useMemo(() => createElement(BaseTableCell, {
        BorderStyle: props.BorderStyle,
        Content: props.Text,
        OnClick: unwrap(props.OnClick),
        Row: props.Row,
        TestId: props.TestId,
        Width: props.Cell.column.getSize(),
    }), dependencies_1);
}

export function DateTimeTableCell(props) {
    const dependencies_1 = [props.Date, props.Cell];
    return reactApi.useMemo(() => {
        let Content, Width;
        return createElement(BaseTableCell, (Content = defaultArg(map_1((date) => toString(toLocalTime(date), "dd.MM.yyyy HH:mm"), props.Date), ""), (Width = (props.Cell.column.getSize() | 0), {
            BorderStyle: props.BorderStyle,
            Content: Content,
            OnClick: unwrap(props.OnClick),
            Row: props.Row,
            TestId: defaultArg(map_1((date_1) => toString(toLocalTime(date_1), "dd.MM.yyyy HH:mm"), props.Date), ""),
            Width: Width,
        })));
    }, dependencies_1);
}

export function DateTableCell(props) {
    const dependencies_1 = [props.Date, props.Cell];
    return reactApi.useMemo(() => createElement(BaseTableCell, {
        BorderStyle: props.BorderStyle,
        Content: defaultArg(map_1((date) => toString(toLocalTime(date), "dd.MM.yyyy"), props.Date), ""),
        OnClick: unwrap(props.OnClick),
        Row: props.Row,
        TestId: props.TestId,
        Width: props.Cell.column.getSize(),
    }), dependencies_1);
}

export function ComponentTableCell(props) {
    const dependencies_1 = [props.Component, props.Cell];
    return reactApi.useMemo(() => createElement(BaseTableCell, {
        BorderStyle: props.BorderStyle,
        Content: props.Component,
        OnClick: unwrap(props.OnClick),
        Row: props.Row,
        TestId: "component-table-cell",
        Width: props.Cell.column.getSize(),
    }), dependencies_1);
}

export function LabelTableCell(props) {
    const labels = props.Labels;
    const leaves = filter((label) => !exists((l) => equals(l.ParentLabelId, label.Id), labels), labels);
    const hierarchyName = (leaf) => labelHierarchyName(labels, leaf);
    const dependencies_1 = [props.Labels, props.Cell];
    return reactApi.useMemo(() => {
        let elems_1;
        return createElement(BaseTableCell, {
            BorderStyle: props.BorderStyle,
            Content: reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-1"])], (elems_1 = toList(delay(() => map_3((leaf_1) => {
                let elems, Child, Tooltip;
                return reactElement_1("div", createObj(ofArray([["className", join(" ", ["max-w-full", "min-w-0"])], (elems = [createElement(TooltipAnchor, (Child = createElement(Badge, {
                    Color: leaf_1.ColorHex,
                    Label: hierarchyName(leaf_1),
                    TestId: concat("label-badge-", ...leaf_1.Name),
                }), (Tooltip = reactElement_1("div", {
                    className: join(" ", ["bg-white", "shadow-xl", "shadow-slate-400", "rounded-md", "px-3", "py-2", "text-sm", "text-black", "outline-none"]),
                    children: hierarchyName(leaf_1),
                }), {
                    Child: Child,
                    TestId: concat("label-badge-tooltip-", ...leaf_1.Name),
                    Tooltip: Tooltip,
                })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
            }, leaves))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
            OnClick: unwrap(props.OnClick),
            Row: props.Row,
            TestId: "label-table-cell",
            Width: props.Cell.column.getSize(),
        });
    }, dependencies_1);
}

export function ImageTableCell(props) {
    const patternInput = reactApi.useState(false);
    const setIsImageViewerOpen = patternInput[1];
    const isImageViewerOpen = patternInput[0];
    const dependencies_1 = [props.ImageUrls, props.Cell, isImageViewerOpen];
    return reactApi.useMemo(() => {
        let elems;
        return createElement(BaseTableCell, {
            BorderStyle: props.BorderStyle,
            Content: reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center"])], (elems = [reactElement_1("img", {
                src: defaultArg(map_1((_arg_1) => _arg_1.ImageUrl, tryFind((image) => (image.Position === 1), props.ImageUrls)), ""),
                className: join(" ", ["max-w-[40px]", "z-10"]),
                onClick: (_arg_2) => {
                    setIsImageViewerOpen(true);
                },
            }), ImageViewer({
                Images: map_2((image_1) => ({
                    Src: image_1.ImageUrl,
                }), sortBy((_arg_3) => (_arg_3.Position | 0), props.ImageUrls, {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                })),
                IsOpen: isImageViewerOpen,
                OnClose: () => {
                    setIsImageViewerOpen(false);
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))),
            Row: props.Row,
            TestId: `${props.ImageUrls}-table-cell`,
            Width: props.Cell.column.getSize(),
        });
    }, dependencies_1);
}

export function ButtonTableCell(props) {
    const dependencies_1 = [props.ButtonContent, props.Cell];
    return reactApi.useMemo(() => {
        let Content, Width;
        return createElement(BaseTableCell, (Content = createElement(TextButton, {
            ComponentState: "enabled",
            Label: props.ButtonContent.Label,
            OnClick: props.ButtonContent.OnClick,
            TestId: "",
            Variant: "blueButton",
        }), (Width = (props.Cell.column.getSize() | 0), {
            BorderStyle: props.BorderStyle,
            Content: Content,
            Row: props.Row,
            TestId: concat(props.ButtonContent.Label, ..."-table-cell"),
            Width: Width,
        })));
    }, dependencies_1);
}

export function CheckboxTableCell(props) {
    const dependencies_1 = [props.Checked, props.OnCheck];
    return reactApi.useMemo(() => {
        let elems_1, elems;
        return reactElement_1("div", createObj(ofArray([["data-test-id", "checkbox-table-cell"], ["className", join(" ", toList(delay(() => append(singleton("grow"), delay(() => {
            let matchValue;
            return append((matchValue = props.BorderStyle, (matchValue === "full") ? singleton("border") : ((matchValue === "row") ? singleton("border-y") : (empty_1()))), delay(() => append(singleton("border-border"), delay(() => append(singleton("py-2.5"), delay(() => append(singleton("px-4"), delay(() => singleton("group-hover:bg-[#F2F4FD]")))))))));
        })))))], ["style", {
            minWidth: 40,
            width: 40,
        }], (elems_1 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["group-hover:bg-[#F2F4FD]", "flex", "items-center", "grow"])], (elems = [Checkbox({
            ComponentState: "enabled",
            IsChecked: props.Checked,
            Label: "",
            OnCheck: props.OnCheck,
            TestId: "",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, dependencies_1);
}

export function BaseTable(props) {
    let elems_5;
    const dependencies = [props.GlobalSearch];
    reactApi.useEffect(() => {
        const matchValue = props.GlobalSearch;
        if (matchValue == null) {
        }
        else {
            const globalSearch = matchValue;
            props.Table.setGlobalFilter(globalSearch);
        }
    }, dependencies);
    let additionalColumns;
    const matchValue_1 = props.Options.RowSelection;
    switch (matchValue_1) {
        case "singleRow":
        case "multiRow": {
            additionalColumns = 2;
            break;
        }
        default:
            additionalColumns = 1;
    }
    return reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("bg-white"), delay(() => append(singleton("rounded-md"), delay(() => {
        let matchValue_2;
        return append((matchValue_2 = props.Options.BorderStyle, (matchValue_2 === "row") ? (empty_1()) : ((matchValue_2 === "none") ? (empty_1()) : singleton("border"))), delay(() => append(singleton("border-border"), delay(() => append(singleton("w-full"), delay(() => append(singleton("grid"), delay(() => append(singleton("grid-rows-[auto,1fr]"), delay(() => {
            const matchValue_3 = props.Options.RowSelection;
            switch (matchValue_3) {
                case "singleRow":
                case "multiRow":
                    return singleton("grid-cols-[50px,repeat(fit-content,minmax(100px,1fr))]");
                default:
                    return singleton("grid-cols-[repeat(fit-content,minmax(100px,1fr))]");
            }
        }))))))))));
    })))))))], (elems_5 = toList(delay(() => {
        let matchValue_4, elems;
        return append((matchValue_4 = props.Options.RowSelection, (matchValue_4 === "singleRow") ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["col-start-1", "flex", "sticky", "top-0", "print:hidden"])], (elems = [createElement(CheckboxTableHeader, {
            BorderStyle: props.Options.BorderStyle,
            Checked: props.Table.getIsAllRowsSelected(),
            IsCheckboxVisible: props.Options.RowSelection === "multiRow",
            OnCheck: (arg) => {
                props.Table.toggleAllRowsSelected(arg);
            },
            StickyHeader: props.Options.StickyHeader,
            Table: props.Table,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : ((matchValue_4 === "multiRow") ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["col-start-1", "flex", "sticky", "top-0", "print:hidden"])], (elems = [createElement(CheckboxTableHeader, {
            BorderStyle: props.Options.BorderStyle,
            Checked: props.Table.getIsAllRowsSelected(),
            IsCheckboxVisible: props.Options.RowSelection === "multiRow",
            OnCheck: (arg) => {
                props.Table.toggleAllRowsSelected(arg);
            },
            StickyHeader: props.Options.StickyHeader,
            Table: props.Table,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : (empty_1()))), delay(() => append(ofArray(collect((x) => x, map((headerGroup) => mapIndexed((headerIndex, header) => {
            let elems_1, Key, Text$, ColumnFilter, matchValue_5, FilterValue, OnFilter, objectArg_1;
            return reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "sticky", "top-0"])], ["style", {
                gridColumnStart: headerIndex + additionalColumns,
            }], (elems_1 = [createElement(TableHeader, (($value) => { $value.key = $value.Key; return $value; })((Key = header.id, (Text$ = header.column.columnDef.header, (ColumnFilter = ((matchValue_5 = tryFind_2(header.id, props.ColumnDefinitionsMap), (matchValue_5 == null) ? "none" : matchValue_5.Filter)), (FilterValue = header.column.getFilterValue(), (OnFilter = ((objectArg_1 = header.column, (arg_1) => {
                objectArg_1.setFilterValue(arg_1);
            })), {
                BorderStyle: props.Options.BorderStyle,
                ColumnDefinitionMap: props.ColumnDefinitionsMap,
                ColumnFilter: ColumnFilter,
                ColumnId: header.id,
                FilterValue: FilterValue,
                Header: header,
                IsDraggable: props.IsHeaderDraggable,
                Key: Key,
                OnFilter: OnFilter,
                SetHeaderSize: true,
                SetQueryParams: false,
                StickyHeader: props.Options.StickyHeader,
                Table: props.Table,
                Text: Text$,
            })))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        }, headerGroup.headers), props.Table.getHeaderGroups()))), delay(() => ofArray(mapIndexed((rowIndex, row) => {
            let elems_4;
            return reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("contents"), delay(() => append((props.Options.OnRowClick != null) ? singleton("hover:cursor-pointer") : empty_1(), delay(() => singleton("group"))))))))], (elems_4 = toList(delay(() => {
                let matchValue_6, elems_2;
                return append((matchValue_6 = props.Options.RowSelection, (matchValue_6 === "multiRow") ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["col-start-1", "flex", "group-hover:bg-[#F2F4FD]", "print:hidden"])], (elems_2 = [createElement(CheckboxTableCell, {
                    BorderStyle: props.Options.BorderStyle,
                    Checked: row.getIsSelected(),
                    OnCheck: (arg_2) => {
                        row.toggleSelected(arg_2);
                    },
                    Row: row,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : ((matchValue_6 === "singleRow") ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["col-start-1", "flex", "group-hover:bg-[#F2F4FD]", "print:hidden"])], (elems_2 = [createElement(CheckboxTableCell, {
                    BorderStyle: props.Options.BorderStyle,
                    Checked: row.getIsSelected(),
                    OnCheck: (arg_2) => {
                        row.toggleSelected(arg_2);
                    },
                    Row: row,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : (empty_1()))), delay(() => mapIndexed((cellIndex, cell) => {
                    let elems_3;
                    const columnDefinition_1 = FSharpMap__get_Item(props.ColumnDefinitionsMap, cell.column.id);
                    return reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex-1", "flex", "group-hover:bg-[#F2F4FD]"])], ["style", {
                        gridColumnStart: cellIndex + additionalColumns,
                    }], (elems_3 = toList(delay(() => {
                        const matchValue_7 = columnDefinition_1.AccessorFunction(row.original);
                        return (matchValue_7.tag === 6) ? singleton(createElement(DateTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Date: unwrap(matchValue_7.fields[0]),
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                            TestId: `row-${rowIndex}-column-${columnDefinition_1.Id}`,
                        })) : ((matchValue_7.tag === 7) ? singleton(createElement(DateTimeTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Date: matchValue_7.fields[0],
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                        })) : ((matchValue_7.tag === 1) ? singleton(createElement(ComponentTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Component: matchValue_7.fields[0],
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                        })) : ((matchValue_7.tag === 3) ? singleton(createElement(LabelTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            Labels: matchValue_7.fields[0],
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                        })) : ((matchValue_7.tag === 4) ? singleton(createElement(ImageTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            ImageUrls: singleton_1({
                                ImageUrl: matchValue_7.fields[0],
                                Position: 1,
                            }),
                            Row: row,
                        })) : ((matchValue_7.tag === 5) ? singleton(createElement(ImageTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            ImageUrls: matchValue_7.fields[0],
                            Row: row,
                        })) : ((matchValue_7.tag === 2) ? singleton(createElement(ButtonTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            ButtonContent: {
                                Label: matchValue_7.fields[0],
                                OnClick: matchValue_7.fields[1],
                            },
                            Cell: cell,
                            Row: row,
                        })) : singleton(createElement(TextTableCell, {
                            BorderStyle: props.Options.BorderStyle,
                            Cell: cell,
                            OnClick: unwrap(props.Options.OnRowClick),
                            Row: row,
                            TestId: `row-${rowIndex}-column-${columnDefinition_1.Id}`,
                            Text: matchValue_7.fields[0],
                        }))))))));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                }, row.getVisibleCells())));
            })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
        }, props.Table.getRowModel().rows))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export class TableControl$1 extends Record {
    constructor(Label, Icon, OnClick, EnabledOnlyOnSelection, EnabledOnlyOnSingleSelection, TestId) {
        super();
        this.Label = Label;
        this.Icon = Icon;
        this.OnClick = OnClick;
        this.EnabledOnlyOnSelection = EnabledOnlyOnSelection;
        this.EnabledOnlyOnSingleSelection = EnabledOnlyOnSingleSelection;
        this.TestId = TestId;
    }
}

export function TableControl$1_$reflection(gen0) {
    return record_type("Widgets.TableModule.TableControl`1", [gen0], TableControl$1, () => [["Label", string_type], ["Icon", option_type(class_type("Fable.React.ReactElement"))], ["OnClick", option_type(lambda_type(list_type(gen0), unit_type))], ["EnabledOnlyOnSelection", bool_type], ["EnabledOnlyOnSingleSelection", bool_type], ["TestId", string_type]]);
}

export class TableControlElement$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TableControl", "TableControlList"];
    }
}

export function TableControlElement$1_$reflection(gen0) {
    return union_type("Widgets.TableModule.TableControlElement`1", [gen0], TableControlElement$1, () => [[["Item", TableControl$1_$reflection(gen0)]], [["label", string_type], ["Item2", list_type(TableControl$1_$reflection(gen0))]]]);
}

export function Table(props) {
    let columns, getCoreRowModel, getFilteredRowModel, getSortedRowModel, state_2, enableRowSelection, matchValue, matchValue_1, elems_6;
    const patternInput = useTranslation();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.TableKey, props.Options.SaveTableConfiguration, props.Options.DefaultColumnFilter, props.Options.DefaultSortColumn, false, props.ColumnDefinitions), update_1, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const dependencies_2 = [props.ColumnDefinitions];
    reactApi.useEffect(() => {
        dispatch(new TableMsg$1(0, [props.ColumnDefinitions]));
    }, dependencies_2);
    const dependencies_4 = [state_1.IsFullscreen];
    reactApi.useEffect(() => {
        if (props.Options.Fullscreen) {
            document.addEventListener("keydown", (e) => {
                if ((e.key === "Escape") && state_1.IsFullscreen) {
                    dispatch(new TableMsg$1(4, []));
                }
            });
        }
    }, dependencies_4);
    const table = useReactTable((columns = createColumnDefinition(props.ColumnDefinitions, state_1.ColumnFilters), (getCoreRowModel = getCoreRowModel_1(), (getFilteredRowModel = getFilteredRowModel_1(), (getSortedRowModel = getSortedRowModel_1(), (state_2 = {
        columnFilters: state_1.ColumnFilters,
        columnOrder: state_1.ColumnOrder,
        columnVisibility: getColumnVisibilityObject(props.ColumnDefinitions, state_1.VisibleColumns),
        rowSelection: state_1.SelectedRows,
        sorting: state_1.ColumnSorting,
    }, (enableRowSelection = ((matchValue = props.Options.RowSelection, (matchValue === "singleRow") ? true : (matchValue === "multiRow"))), {
        columnResizeMode: "onChange",
        columns: columns,
        data: props.TableRows,
        debugTable: false,
        defaultColumn: {
            maxSize: 10000,
            minSize: 75,
            size: 200,
        },
        enableGlobalFilter: true,
        enableMultiRowSelection: (matchValue_1 = props.Options.RowSelection, (matchValue_1 === "singleRow") ? false : (matchValue_1 === "multiRow")),
        enableRowSelection: enableRowSelection,
        enableSortingRemoval: false,
        getCoreRowModel: getCoreRowModel,
        getFilteredRowModel: getFilteredRowModel,
        getSortedRowModel: getSortedRowModel,
        onColumnFiltersChange: (filterUpdater) => {
            dispatch(new TableMsg$1(5, [filterUpdater(state_1.ColumnFilters)]));
        },
        onColumnOrderChange: (arg) => {
            dispatch(new TableMsg$1(9, [arg]));
        },
        onColumnVisibilityChange: (visibilityUpdater) => {
            dispatch(new TableMsg$1(8, [visibilityUpdater(state_1.VisibleColumns)]));
        },
        onRowSelectionChange: (rowSelectionUpdater) => {
            dispatch(new TableMsg$1(2, [rowSelectionUpdater(state_1.SelectedRows)]));
        },
        onSortingChange: (sortingUpdater) => {
            dispatch(new TableMsg$1(7, [sortingUpdater(state_1.ColumnSorting)]));
        },
        state: state_2,
    })))))));
    return reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => (state_1.IsFullscreen ? append(singleton("fixed"), delay(() => append(singleton("inset-0"), delay(() => append(singleton("z-[15]"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => singleton("pt-6"))))))))))))) : singleton("h-[calc(100%-40px)]")))))], (elems_6 = toList(delay(() => {
        let elems_4, elems, elems_3;
        return append(((((!isEmpty(props.Controls) ? true : props.Options.ConfigurableColumns) ? true : props.Options.GlobalSearch) ? true : props.Options.CSVDownload) ? true : props.Options.Fullscreen) ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("px-6"), delay(() => append(singleton("top-[0px]"), delay(() => append(singleton("left-1"), delay(() => append(singleton("bg-[#fefefe]"), delay(() => append(singleton("z-10"), delay(() => {
            const matchValue_2 = props.Options.BorderStyle;
            switch (matchValue_2) {
                case "full":
                case "none": {
                    return empty_1();
                }
                default:
                    return append(singleton("border-b"), delay(() => singleton("border-border")));
            }
        })))))))))))))))], (elems_4 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-5", "grow", "print:hidden"])], (elems = toList(delay(() => map_2((control) => {
            let OnClick, matchValue_3, onClick, array_2;
            return createElement(TextButton, (OnClick = ((matchValue_3 = control.OnClick, (matchValue_3 == null) ? (() => {
            }) : ((onClick = matchValue_3, () => {
                onClick(ofArray(map((row) => row.original, table.getSelectedRowModel().rows)));
                table.toggleAllRowsSelected(false);
            })))), {
                ComponentState: (control.EnabledOnlyOnSingleSelection && (props.Options.RowSelection === "multiRow")) ? ((table.getSelectedRowModel().rows.length === 1) ? "enabled" : "disabled") : (control.EnabledOnlyOnSelection ? (((array_2 = table.getSelectedRowModel().rows, array_2.length === 0)) ? "disabled" : "enabled") : "enabled"),
                Icon: unwrap(control.Icon),
                Label: control.Label,
                OnClick: OnClick,
                TestId: control.TestId,
                Variant: "default",
            }));
        }, props.Controls))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-5", "py-5", "print:hidden"])], (elems_3 = toList(delay(() => append(singleton(createElement(TableElementsCounter, {
            NumberOfElements: table.getRowModel().rows.length,
        })), delay(() => append(props.Options.GlobalSearch ? singleton(createElement(IconInput, {
            ComponentState: "enabled",
            LeftIcon: Magnifying_Glass(),
            OnChange: (arg_1) => {
                dispatch(new TableMsg$1(1, [arg_1]));
            },
            TestId: "",
            Value: state_1.GlobalSearchPattern,
        })) : empty_1(), delay(() => append(props.Options.ConfigurableColumns ? singleton(createElement(ColumnSelect, {
            ButtonLabel: patternInput[0]("table.columns"),
            ComponentState: "enabled",
            Items: ofArray(map((column) => {
                let matchValue_4;
                const Id = column.columnDef.id;
                return {
                    Checked: column.getIsVisible(),
                    Group: (matchValue_4 = FSharpMap__TryFind(state_1.ColumnDefinitionMap, column.id), (matchValue_4 == null) ? "" : matchValue_4.Group),
                    Id: Id,
                    Name: column.columnDef.header,
                    OnCheck: (_arg_5) => {
                        column.toggleVisibility(!column.getIsVisible());
                    },
                };
            }, table.getAllLeafColumns())),
            TestId: "",
        })) : empty_1(), delay(() => append(props.Options.CustomTableFilters ? singleton(createElement(TableFilterDropDown, {
            ColumnDefinitionMap: state_1.ColumnDefinitionMap,
            ColumnFilters: state_1.ColumnFilters,
            CustomTableFilters: true,
            Dispatch: dispatch,
            SavedFilters: state_1.SavedFilters,
        })) : empty_1(), delay(() => append(singleton(createElement(TableSettings, {
            CSVDownloadActivated: props.Options.CSVDownload,
            CSVDownloadRunning: state_1.CSVDownloadRunning,
            ColumnDefinitionMap: state_1.ColumnDefinitionMap,
            Dispatch: dispatch,
            ResetConfigurationEnabled: props.Options.SaveTableConfiguration,
            ResetFilterEnabled: props.ColumnDefinitions.some((columnDefinition) => (columnDefinition.Filter !== "none")),
            Table: table,
        })), delay(() => {
            let elems_2, elems_1;
            return props.Options.Fullscreen ? singleton(reactElement_1("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "cursor-pointer"])], ["onClick", (_arg_6) => {
                dispatch(new TableMsg$1(4, []));
            }], (elems_2 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5"])], (elems_1 = toList(delay(() => (state_1.IsFullscreen ? singleton(Compress()) : singleton(Expand())))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_1();
        })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty_1(), delay(() => {
            let elems_5;
            return singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(state_1.IsFullscreen ? singleton("flex-1") : singleton("h-[calc(100%-80px)]"), delay(() => append(singleton("overflow-x-auto"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("grow"), delay(() => append(singleton("print:overflow-visible"), delay(() => append(singleton("print:w-full"), delay(() => singleton("print:block"))))))))))))))))], (elems_5 = [createElement(BaseTable, {
                ColumnDefinitions: props.ColumnDefinitions,
                ColumnDefinitionsMap: state_1.ColumnDefinitionMap,
                GlobalSearch: state_1.GlobalSearchPattern,
                IsHeaderDraggable: props.Options.SaveTableConfiguration,
                Options: {
                    BorderStyle: props.Options.BorderStyle,
                    ConfigurableColumns: props.Options.ConfigurableColumns,
                    OnRowClick: unwrap(props.Options.OnRowClick),
                    RowSelection: props.Options.RowSelection,
                    StickyHeader: true,
                },
                Table: table,
                TableRows: props.TableRows,
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

